module.exports = __webpack_public_path__ + "assets/4bce56ee4aeb31c8e2333b9abead0158.mp3";